import React, { useState } from 'react';
import { auth, googleProvider, db } from '../../services/firebaseConnection';
import { signInWithPopup, signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { setDoc, doc, getDoc } from 'firebase/firestore';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import LogoBarberia from '../../assets/LogoBarbearia.png';


export default function LoginBarbe() {
    const [googleData, setGoogleData] = useState(null);
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isRegistering, setIsRegistering] = useState(false); // Toggle entre login e registro
    const [password, setPassword] = useState("");
    const [phone, setPhone] = useState("");
    const navigate = useNavigate();


    async function registerWithEmail() {
        if (password !== confirmPassword) {
            console.error("As senhas não coincidem!");
            return;
        }
        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            const userDoc = doc(db, 'propietario', user.uid);
            const userData = {
                name: name,
                email: email,
                phone: phone
            };
            await setDoc(userDoc, userData);

            navigate('/homeBarbe');
        } catch (error) {
            console.error("Erro ao registrar:", error);
        }
    }

    async function signInWithEmail() {
        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            navigate('/homeBarbe');
        } catch (error) {
            console.error("Erro ao entrar:", error);
        }
    }

    // ativar caso use criar conta com google 

    //   async function signInWithGoogle() {
    //     try {
    //         const { user } = await signInWithPopup(auth, googleProvider);
    //         const userDocRef = doc(db, 'users', user.uid);
    //         const userDoc = await getDoc(userDocRef);

    //         if (userDoc.exists()) {
    //             // User already registered, redirect to another page
    //             navigate('/homeCli');
    //         } else {
    //             // User not registered, set data to finalize registration
    //             setGoogleData(user);
    //         }
    //     } catch (error) {
    //         console.error("Error signing in with Google:", error);
    //     }
    // }

    async function finalizeRegistration() {
        if (!googleData) {
            console.error("Google data not set!");
            return;
        }

        const userDoc = doc(db, 'propietario', googleData.uid);
        const userData = {
            name: googleData.displayName,
            email: googleData.email,
            phone: phone
        };

        try {
            await setDoc(userDoc, userData);
            console.log("User data saved successfully!");
            navigate('/homeBarbe');
        } catch (error) {
            console.error("Error saving user data:", error.message, "\nCode:", error.code);
        }

    }

    return (
        <div className="login-container">
            <h1 className="login-title">Corte's curte</h1>
            <div className='box-logo'>
                <img src={LogoBarberia} alt="Logo" className="logoo" />
                <p>Login do Barbeiro.</p>
            </div>
            <div className="login-box">
                {!googleData ? (
                    isRegistering ? (
                        <>
                            <input type="text" className="login-input" placeholder="Nome" value={name} onChange={e => setName(e.target.value)} />
                            <input type="email" className="login-input" placeholder="E-mail" value={email} onChange={e => setEmail(e.target.value)} />
                            <input type="text" className="login-input" placeholder="Telefone" value={phone} onChange={e => setPhone(e.target.value)} />
                            <input type="password" className="login-input" placeholder="Senha" value={password} onChange={e => setPassword(e.target.value)} />
                            <input type="password" className="login-input" placeholder="Confirme sua senha" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
                            <button className="register-button" onClick={registerWithEmail}>Finalizar registro</button>
                        </>
                    ) : (
                        <>
                            <input type="email" className="login-input" placeholder="E-mail" value={email} onChange={e => setEmail(e.target.value)} />
                            <input type="password" className="login-input" placeholder="Senha" value={password} onChange={e => setPassword(e.target.value)} />
                            {/* <a href="/password-reset" className="forgot-password">Esqueceu sua senha?</a> */}
                            <button className="login-button" onClick={signInWithEmail}>Entrar</button>
                            {/* <button className="google-button" onClick={signInWithGoogle}>Continuar com Google</button> */}
                            {/* <p className="register-text">Não possui uma conta?</p>
                            <button className="register-button" onClick={() => setIsRegistering(true)}>Criar conta</button> */}
                        </>
                    )
                ) : (
                    <>
                        <input type="text" className="login-input" placeholder="Nome" defaultValue={googleData.displayName} readOnly />
                        <input type="email" className="login-input" placeholder="E-mail" defaultValue={googleData.email} readOnly />
                        <input type="text" className="login-input" placeholder="Telefone" value={phone} onChange={e => setPhone(e.target.value)} />
                        <button className="register-button" onClick={finalizeRegistration}>Criar conta</button>
                    </>
                )}
            </div>
        </div>
    );
}
